import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlphabetPipe } from './pipes/alphabet.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { SearchComponent } from './components/search/search.component';
import { TimeslotsAvailabilityPipe } from './pipes/timeslots-availability.pipe';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule, MatInputModule } from '@angular/material';

const modules = [
  CommonModule,
  TranslateModule,
  FormsModule,
  MatInputModule,
  MatFormFieldModule,
];

const components = [
  SearchComponent
];

const pipes = [
  AlphabetPipe,
  TimeslotsAvailabilityPipe
];

@NgModule({
  declarations: [...components, ...pipes],
  exports: [...components, ...pipes, ...modules],
  imports: [...modules]
})
export class SharedModule { }
